export const PRODUCTION = 'production'
export const DEVELOPMENT = 'development'
export const TEST = 'test'



// WEBPACK FOOTER //
// ./src/constants/env.js